(ns motorsaif.web.components.step-inputs
  (:require
   [clojure.string :as str]
   [motorsaif.web.lib.form :as form]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.user-handle :as c-handle]
   [motorsaif.constants :as constants]
   [motorsaif.data-utils :as data-utils]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.log :as log]
   [motorsaif.vars :refer [inline-env]]
   [motorsaif.malli :as malli]
   [motorsaif.string :as mstr :refer [format]]
   [motorsaif.validation :as validation]
   [re-frame.core :as rf :refer [subscribe]]
   [reagent.core :as r]
   [reagent.ratom :as ra]
   [taoensso.encore :as encore]))

;; Step form allows composing different groups of inputs together
;; This file contains all sets of steps for various forms


(defn services-v2
  "TODO Refactor later to use the same code as non components/services.

  Copy pasted to quickly integrate easily with the new business sign up step form
  but also keep functionality for previous form and feed filters.
  "
  [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :services])
        {:keys [check *data input select set-val get-val]} form
        base-path [:business :business/misc :filters 0]
        path-fn #(vec (concat base-path (data-utils/ensure-vec %)))

        get-val (fn [path]
                  (get-val (path-fn path)))

        set-val (fn [path afn]
                  (set-val (path-fn path) afn))

        make-models @(subscribe [:makes-models])

        makes (->> (keys make-models)
                   (mapv #(hash-map
                           :img (format "/static/img/car-makes/%s.png" (str/replace % " " "_"))
                           :value %))
                   (sort-by :title))
        years (mapv #(hash-map :title % :value %) (reverse (range 1940 2025)))
        get-models (fn [make]
                     (mapv #(hash-map :value %)
                           (get make-models make)))
        ;; *make (ra/reaction (get-val [:make]))
        *tags (subscribe [:tags])
        ;; *selected (r/atom {:makes {}
        ;;                    :year {:min nil
        ;;                           :max nil}})
        *current-make (r/atom nil)
        make-toggle-fn (fn [make val]
                         (let [path [:makes make]]
                           (if (get-val path)
                             (do
                               (if (= @*current-make make)
                                 (do
                                   (println "Should remove")
                                   (reset! *current-make nil)
                                   (set-val :makes #(dissoc % make)))
                                 (reset! *current-make make)))
                             (do
                               (reset! *current-make make)
                               (set-val path #{})))))
        model-toggle-fn (fn [make model]
                          (let [path [:makes make]]
                            (if ((get-val path) model)
                              (set-val path #(disj % model))
                              (set-val path #(conj % model)))))
        *get-models-fn (fn [value] (ra/reaction (get-val [:makes value])))]
    (fn []
      [:div#service-filters
       [:div.added-tags]
       ;; [:business :business/misc :filters]
       ;; (str (:business/misc (:business @*data)))
       [:div.grid-wrap
        [:div.mid.scroll-section
         [:section
          [:h3.title (trs :business-type "Business Type")]
          [check
           (mapv (fn [[[val title]]]
                   {:title title
                    :value val})
                 (map vec constants/service-types))
           {:class "horizontal small variant-button"}
           (path-fn [:type])]]
         [:section
          [:h3.title (trs :categories "Categories")]
          [check
           (mapv (fn [{id :db/id
                       title :tag/title}]
                   {:title title
                    :value id})
                 @*tags)
           {:class "horizontal small variant-button"}
           (path-fn [:tag])]]

         [:section
          [c/accordion
           (fn [open?]
             [:h3.title (trs :year "Year")
              " "
              (if open?
                [:i.fa-regular.fa-chevron-up]
                [:i.fa-regular.fa-chevron-down])])

           (fn []
             [:div.year-min-max
              [select
               years
               {:label (trs :year-min "Year Min")
                :placeholder (trs :select-year "Select Year")}
               (path-fn [:year :min])]

              [select
               years
               {:label (trs :year-max "Year Max")
                :placeholder (trs :select-year "Select Year")}
               (path-fn [:year :max])]])]]

         [:section.makes-wrap
          [c/accordion
           (fn [open?]
             [:h3.title (trs :makes "Makes")
              " "
              (if open?
                [:i.fa-regular.fa-chevron-up]
                [:i.fa-regular.fa-chevron-down])])
           (fn []
             [:div
              (into [:div.makes]
                    (map (fn [{:keys [value img]}]
                           (let [models @(*get-models-fn value) #_(get-val [:makes value])
                                 c (count models)]
                             [:button.make.reset-btn
                              {:on-click #(make-toggle-fn value #{})
                               :type "button"
                               :class
                               (str (when models "active")
                                    (when (= value @*current-make) " current"))}
                              [:img {:src img}]
                              [:div.count
                               (when models
                                 (if (> c 0)
                                   (count models)
                                   (trs :all "All")))]
                              [:div.title value]]))
                         (sort-by :value makes)))
              (when @*current-make
                [:div.models-wrap
                 [:h3.title (format "%s %s " @*current-make "Models")]
                 [:div
                  (if-let [models (seq (get-models @*current-make))]
                    (into [:div.models]
                          (map (fn [{:keys [value]}]
                                 (let [active? ((get-val [:makes @*current-make]) value)]
                                   [:button.model.reset-btn
                                    {:on-click #(model-toggle-fn @*current-make value)
                                     :type "button"
                                     :class (when active? "active")}
                                    [:div.title value]]))
                               models))
                    [:div (trs :select-make "Select a make")])]])])]]]]])))

(defn services [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :services])
        {:keys [*data]} form]
    (fn []
      [:div
       [:h1 (trs :services "Services")]
       [:ul.desc
        [:li (trs :desc-1 "This will show you only the customer requests that you care about")]]
       [services-v2 {:form form}]
       [:ul.desc
        [:li (trs :desc-2 "Choose all applicable services you offer")]
        [:li (trs :desc-3 "You can get specific by selecting makes and models")]]])))

(defn photos [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :photos])
        {:keys [uploader uploaded-media  get-val retract-fn]} form]
    [:div.form-section
     [:h3 (trs :photos "Photos")]
     [:p (trs :desc "Let users see what your business looks like")]
     [:p (trs :optional "*Optional")]
     [:div#issues
      (let [media-path [:business :business/media]]
        [:div
         [:div.full-upload-wrapper
          [uploaded-media
           {:after-remove
            (fn [{id :db/id :as itm}]
              (let [parent-id (get-val [:business :db/id])]
                (retract-fn {:parent-id parent-id
                             :key :business/media
                             :item-id id})))}
           media-path]
          [uploader media-path]]])]]))

(defn business-information [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :business-information])
        {:keys [input get-val set-val *realtime-validation]} form]
    [:div
     [:h1 (tr :title "Business Account")]
     [:div
      [input
       {:label (trs [:name :label] "Business Name")}
       [:business :business/name]]
      [input
       {:label (trs [:email :label] "Business Email")}
       [:business :business/email]]
      [:ul.desc
       [:li (trs :desc-1 "You will be added as an owner to this business account")]
       [:li (trs :desc-2 "Customers will see your business name and email publicly when you livechat with them")]
       [:li (trs :desc-3 "You will be able to add employees to your business account")]]]]))

(defn biz-personal-account [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :business-personal-account])
        {:keys [input get-val]} form]
    [:div
     [:h1 (trs :title "Personal Account")]
     [:div
      [input {:label (trs [:email :label] "Email")}
       [:user :user/email]]
      [c-handle/username-input
       {:form form
        :label (trs [:username :label] "Username")
        :helper (trs [:username :helper] "No spaces")
        :path [:user :user/handle]}]
      [input {:label (trs [:password :label] "Password")
              :helper (trs [:password :helper] "At least 4 characters")
              :type "password"}
       [:user :user/password]]]
     [:ul.desc
      [:li (trs :desc-1 "Your personal account will be used to login to MotorSaif")]
      [:li (trs :desc-2 "This will be linked to your business account")]]]))



(defn personal-account [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :personal-account])
        {:keys [input get-val]} form]
    [:div#personal-account.step-input-variant-1.elevated
     [:h1 (trs :title "Personal Account")]
     [:div
      [input {:label (trs [:email :label] "Email")}
       [:user :user/email]]
      [c-handle/username-input
       {:form form
        :label (trs [:username :label] "Username")
        :path [:user :user/handle]}]
      [input {:label (trs [:password :label] "Password")
              :helper (trs [:password :helper] "At least 4 characters")
              :type "password"}
       [:user :user/password]]]

     [:ul.desc
      [:li (trs :desc-1 "Your personal account will be used to login to MotorSaif")]]
     [:div.or
      "OR"]
     [:div.flex-center
      [c/google-button :sign-up]]]))

#_(defn business-gps-location [{:keys [get-val presentable-error set-val]}]
    (let [path [:business :business/coords]
          default-coords (get-val path)
          on-pos-change (fn [{:keys [geocode lon lat]}]
                          (set-val [:business :business/misc :geo-location] (get-in (js->clj geocode) ["results" 0 "formatted_address"]))
                          (set-val path [lon lat]))

          [lon lat] (or default-coords [55.132 25.069])
          *map (r/atom nil)
          *marker (r/atom nil)
          *jump (r/atom false)

          set-pan (fn [{:keys [lat lng] :as loc}]
                    (reset! *jump false)
                    ^js (.setPosition @*marker (clj->js loc))
                    ^js (.panTo @*map (clj->js loc)))]
      (fn []
        [:div.gps-location
         (when-let [error (presentable-error path)]
           error)
         [c/g-map {:*map *map
                   :*marker *marker
                   :on-pos-change on-pos-change
                   :coords {:lat lat
                            :lng lon}}]
         [:button#jump.btn.primary
          {:on-click #(do
                        (reset! *jump true)
                        (c/get-gps-pos set-pan))
           :type "button"}
          (if @*jump
            (tr :forms.request.gps/locating)
            (tr :forms.request.gps/jump))]])))

(defn location-input [{:keys [get-val set-val presentable-error] :as form-args}]
  (fn []
    (let [path [:business :business/coords]
          default-coords (get-val path)
          on-pos-change (fn [{:keys [geocode lon lat]}]
                          (set-val [:business :business/geo-location] (get-in (js->clj geocode) ["results" 0 "formatted_address"]))
                          (set-val path [lon lat]))
          no-coords [55.132 25.069]]
      [:div
       [:div.gps-location
        (when-let [error (presentable-error path)]
          error)
        [c/gps-location {:on-pos-change on-pos-change
                         :default-coords default-coords}]]
       [(fn []
          [:div.geo-location
           (or (get-val [:business :business/geo-location])
               (tr :forms.request.location/drop-pin))])]])))

(defn location [{:keys [form]}]
  [:div
   [:h1 (tr :forms.request.location/title)]
   [location-input form]
   [:ul.desc
    [:li "Customers will be able to get directions to you"]]])

(let [limiter (encore/rate-limiter {:unique-num-1-per-30s [1 (encore/ms :secs 30)]})
      *limited-fn (atom nil)]
  (defn send-whatsapp-verification
    [{:keys [val *ret]}]
    (let [req {:type :POST
               :url "/api/businesses/whatsapp-send-code"
               :id :username-req
               :params {:phone val}
               :handler (fn [res]
                          (swap! *ret assoc val res))
               :error-handler #(swap! *ret assoc val {:error %})}
          [_ backoff] (limiter val)
          call-fn #(when @*limited-fn
                     (@*limited-fn)
                     (reset! *limited-fn nil))]
      (reset! *limited-fn #(rf/dispatch [:do-ajax req]))
      (if backoff
        (reset! *ret {:backoff backoff})
        (call-fn)))))

(defn verify-whatsapp [{:keys [form *ret]}]
  (let [trs (i18n/tr-scope [:step-inputs :whatsapp])
        {:keys [input get-val set-val]} form
        code-entry (fn [v]
                     (let [num-entered (get-val [:business :business/misc :whatsapp])]
                       (cond
                         (= (get-in @*ret [num-entered :code]) v)
                         (swap! *ret assoc-in [num-entered :verified] true)
                         (>= (count v) 3)
                         (rf/dispatch [:toast {:type "error"
                                               :title "Code Invalid"
                                               :message "Please check your WhatsApp"}]))))]
    (set-val [:business :business/misc :whatsapp-verified] false)
    (r/create-class
      {:component-will-unmount
       (fn []
         (set-val [:business :business/misc] #(dissoc % :whatsapp-verified)))
       :reagent-render
       (fn [{:keys [can-send? val]}]
         [:div#whatsapp-verification
          [:div.input-wrap
           [:button.btn.primary.full
            {:type "button"
             ;; :disabled #_(not (:code @*ret))
             :disabled (not can-send?)
             :on-click #(send-whatsapp-verification
                         {:val (get-val [:business :business/misc :whatsapp])
                          :*ret *ret})}
            (trs :send-code "Send Verification Code")]]
          ^{:key (get-in @*ret [val :code])}
          [:div
           (if (get-in @*ret [val :verified])
             [:div.verified
              [:i.fas.fa-check]
              [:h2
               (trs :verified "WhatsApp verified")]]
             [input {:label (trs [:code :label] "Whatsapp Code")
                     :helper (trs [:code :helper] "Check Whatsapp")
                     :type "number"
                     :placeholder (trs [:code :placeholder] "Send Verification First")
                     :disabled (empty? @*ret)
                     :on-change code-entry}
              [:business :business/misc :whatsapp-verify-code]])]])})))

(defn whatsapp [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :whatsapp])
        {:keys [input set-val get-val]} form
        *ret (r/atom {})
        *verify-reaction (ra/reaction
                           (let [num (get-val [:business :business/misc :whatsapp])
                                 verified (get-in @*ret [num :verified])]
                             (set-val [:business :business/misc :whatsapp-verified] verified)
                             verified))]
    (fn []
      @*verify-reaction
      (let [val (get-val [:business :business/misc :whatsapp])
            valid? (when (seq val)
                     (:valid (malli/validate validation/uae-whatsapp val)))]
        [:div.whatsapp-verification
         [:h1 (trs :title "Whatsapp")]
         ;; (str [:val val :init init-val :ret @*ret :match (get-val [:business :business/misc :whatsapp-verified])])
         [:div
          [input {:label (trs [:whatsapp :label] "Whatsapp")
                  :helper (trs [:whatsapp :helper] "UAE Number")}
           [:business :business/misc :whatsapp]]]
         [verify-whatsapp {:input input
                           :can-send? valid?
                           :form form
                           :val val
                           :*ret *ret}]
         [:ul.desc
          [:li (trs :desc "Your Whatsapp will receive notifications when a request that matches your business is posted")]]]))))



;; https://uxdesign.cc/user-onboarding-practices-that-you-cannot-miss-dff86a5c966a

(defn- new-user-request [{:keys [all-data]}]
  (let [req {:type :POST
             :url "/api/account/verify-code"
             :params {:data
                      (assoc all-data :context :new-user)}
             :id :verify-code
             :handler
             (fn [{:keys [state] :as res}]
               (condp = state
                 :validated
                 (js/window.location.reload)
                 :already-verified
                 (js/window.location.reload)
                 :code-invalid
                 (rf/dispatch [:toast {:type "error"
                                       :message "Code invalid"}])))
             :error-handler (fn [res]
                              (rf/dispatch [:toast {:type "error"
                                                    :message "Backend server error"}]))}]
    (rf/dispatch [:do-ajax req])))

;; TODO: RATE LIMITING

(defn verify-email-new-user
  [{:keys [step-form form]}]
  (let [trs (i18n/tr-scope [:step-inputs :verify-email-new-user])
        {:keys [input get-val set-val]} form
        email (get-val [:user :user/email])

        ;; expected parameters
        *request-ret (atom {:success nil
                            :new-user? nil
                            :backoff nil})
        verify-code (fn [nonce]
                      (when (= (count nonce) 4)
                        (rf/dispatch [:api/verify-code
                                      {:email email
                                       :context :registration
                                       :nonce nonce
                                       :user (get-val [:user])}
                                      #(set-val [:user :user/email-verified] (:success %))])))]

    (rf/dispatch
     [:api/request-code
      {:email email
       :context :registration
       :callback #(reset! *request-ret %)}])
    (fn []
      [:div.step-input-variant-1.elevated
       [:h1 (trs :title "Verification")]
       [:p.info
        [:span (trs :code-sent "Your code was just sent to")]
        [:div.text.med.bold email]
        [:span (trs :check-email " Check your email and spam folder.")]]
       [:div.code
        #_[:input {:on-change (fn [e]
                                (println (forms/event->value e))
                                )}]
        ;; (str "Code" (rand-int 300))
        [input {:placeholder (trs :code "Code")
                :on-change verify-code
                :type :number}
         [:code]]]])))

;; NOTE
;; TWO WAYS to register a user is awful.
;; This business form should NOT include the user stuff, rather
;; the user stuff should segue into the business thing when required.
